import { useAuth } from "@clerk/clerk-react";
import { AlertContext } from "contexts/Alert";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext, useState } from "react";

import { fetcherAuth } from "./api";

export const useBulkSend = () => {
  const { setErrorAlert } = useContext(AlertContext);
  const {
    currentOrg,
    setOrganizationBulkSendSettings,
    setOrganizationVaProfile,
  } = useContext(OrganizationUserContext);
  const { getToken } = useAuth();
  const [settingsLoading, setSettingsLoading] = useState<boolean>(false);

  const fetchOrganizationBulkSendSettings = async () => {
    setSettingsLoading(true);
    try {
      const res = await fetcherAuth(
        getToken,
        `/api/organization/${currentOrg?.id}/bulk-send-settings`,
        "GET",
      );
      if (res.bulkSendSetting) {
        setOrganizationBulkSendSettings(res.bulkSendSetting);
      }
    } catch (error) {
      setErrorAlert(error);
    } finally {
      setSettingsLoading(false);
    }
  };

  const fetchNiches = async () => {
    setSettingsLoading(true);
    try {
      const { niches } = await fetcherAuth(
        getToken,
        `/api/organization/${currentOrg?.id}/organization-niches`,
      );
      setOrganizationVaProfile((prev) => {
        if (prev) {
          prev.niches = niches;
        }
        return prev;
      });
    } catch (error) {
      setErrorAlert(error);
    } finally {
      setSettingsLoading(false);
    }
  };

  return { fetchOrganizationBulkSendSettings, fetchNiches, settingsLoading };
};
